function isEmail(email) {
  var re = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const validDomains = [];
const invalidDomains = [];
let domainRequest;

async function validateEmail(email) {
  
  // The email must start with one or more alphanumeric characters, dots (.), percent signs (%), plus signs (+), or hyphens (-).
  // This is followed by an "@" symbol.
  // Then, there must be one or more alphanumeric characters, dots (.), or hyphens (-).
  // This is followed by a dot (.).
  // Finally, the string must end with two or more alphabetic characters.
  const validEmailStringRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const validEmailString = validEmailStringRegEx.test(email);

  // invalid email string
  if (!email || !validEmailString) {
    return 'invalidString'
  }

  const emailFullDomain = email.split('@').pop();
  const emailDomain = emailFullDomain.split('.').shift();

  const blacklistedDomains = window.SMTX.blacklistedDomains || [];
  
  const isBlacklisted = blacklistedDomains.includes(emailDomain);

  // email domain is blacklisted
  if (isBlacklisted) {
    return 'blacklisted';
  }
  
  if (invalidDomains.includes(emailFullDomain)) {
    return 'invalidDomain';
  }
  
  // if domain has already been validated before, skip the request
  if (validDomains.includes(emailFullDomain)) {
    return 'validDomain';
  }
  
  return new Promise((resolve, reject) => {
    
    if (domainRequest) {
      domainRequest.abort();
    }
    
    let timeoutTimer;
    
    domainRequest = $.ajax({
      url: '/api/emailDomainCheck/',
      type: 'POST',
      data: { domain: emailFullDomain },
    }).always(function ({ status, message }) {
      clearTimeout(timeoutTimer);
      
      if (status !== 'error') {
        validDomains.push(emailFullDomain);
        resolve('validDomain')
      } else {
        console.log('error:', message);
        invalidDomains.push(emailFullDomain);
        resolve('invalidDomain');
      }

      domainRequest = null;
    });
    
    timeoutTimer = setTimeout(function () {
      domainRequest.abort();
      validDomains.push(emailFullDomain);
      resolve('validDomain');
    }, 400);
    
  })
}

function capitalizeWord(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function getCurrency() {
  var currency = '';

  switch (window.SMTX.iq.country_code) {
    case 'GB':
      currency = 'EUR';
      break;
    case 'SE':
      currency = 'SEK';
      break;
    case 'NO':
      currency = 'NOK';
      break;
    case 'DK':
      currency = 'DKK';
      break;
    case 'FI':
      currency = 'EUR';
      break;
    case 'DE':
      currency = 'EUR';
      break;
    default:
      currency = '';
  }

  return currency;
}

function getCountry() {
  //Format: Full country name in English (Sweden, Norway, Denmark, Finland or leave empty if english site)
  var country = '';

  switch (window.SMTX.iq.country_code) {
    case 'FI':
      country = 'Finland';
      break;
    case 'SE':
      country = 'Sweden';
      break;
    case 'NO':
      country = 'Norway';
      break;
    case 'DK':
      country = 'Denmark';
      break;
    case 'DE':
      country = 'Germany';
      break;
    default:
      country = '';
  }

  return country;
}

function humanFileSize(size) {
  var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

function truncateString(str, num) {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + '...';
}

function searchArr(array, key, prop) {
  // Optional, but fallback to key['name'] if not selected
  prop = typeof prop === 'undefined' ? 'name' : prop;

  for (var i = 0; i < array.length; i++) {
    //log((array[i][prop]) + ' == ' + key);
    if (array[i][prop] == key) {
      return i;
    }
  }

  return -1;
}
